export const opening = [
  'O mercado de FIAGRO encerrou dezembro de 2025 com 196 fundos e R$35,6 bilhões de patrimônio líquido. O número é expressivo para um veículo que não existia há cinco anos, mas a fotografia de fim de ano revela um mercado que cresceu mais em escala do que em diversidade: renda fixa e direitos creditórios, juntos, respondiam por 108 fundos e 72,9% do PL total. Imobiliário, participações e cotas dividiam o restante.',
  'A concentração entre prestadores de serviço segue o padrão dos demais mercados de securitização. Os três maiores administradores detinham 43,3% do patrimônio; os cinco primeiros, 66,9%. O maior fundo individual, o Kinea Crédito Agro, respondia por 6,2% do PL total.',
  '2025 trouxe também uma dificuldade concreta para quem acompanha o setor: a reformulação do padrão informacional ao longo do ano prejudicou a comparabilidade entre os dados anteriores e posteriores a setembro. Mudanças de layout, granularidade e preenchimento dos informes reduziram a possibilidade de construir séries contínuas. Para um veículo que pode investir em ativos tão diferentes quanto imóveis rurais, cotas de fundos, títulos de securitização e direitos creditórios, a padronização da informação não é detalhe operacional. É condição para que o mercado consiga se monitorar.',
  'Um dado que merece atenção: nos FIAGROs classificados como Direitos Creditórios, a carteira vencida somava R$769,7 milhões sobre uma base de R$4,37 bilhões, o que implica nível de atraso consolidado de 17,6%. É um percentual alto e precisa ser acompanhado à medida que o segmento cresce.',
];

export const stock = {
  intro: [
    'Em termos de porte, o miolo do mercado está em fundos médios e pequenos (79 e 58 fundos, respectivamente), mas o patrimônio é puxado por 40 fundos grandes. Renda fixa domina: R$21,0 bilhões, 59,0% do PL. Direitos creditórios vêm em seguida com R$4,9 bilhões (13,9%), depois imobiliário com R$3,7 bilhões (10,3%). Fundos classificados como indeterminados ainda somam R$3,4 bilhões (9,4%), sinal de que a padronização informacional continua incompleta.',
    'O perfil de carteira confirma a inclinação do mercado para crédito e renda fixa. Na classificação dos fundos, 70 são de Renda Fixa e 38 de Direitos Creditórios, somando 108 dos 196 fundos. Os 88 restantes se dividem em 43 indeterminados, 24 de cotas, 15 imobiliários e 6 de participações.',
  ],
  charts: [
    {
      title: 'Número de FIAGROs ao longo do ano',
      link: 'https://metabase.uqbaronline.com/question/959-numero-de-fiagros-filtered-by-mes-referencia-is-before-dez-31-2025',
      description:
        '196 fundos reportantes em dezembro de 2025, marcando um crescimento importante frente aos 168 registrados em novembro do mesmo ano. O salto significativo de agosto para setembro reflete a reformulação do padrão informacional ocorrida naquele período.',
      data: [
        { mes_referencia: '2025-05-01', numero_fundos: 3 },
        { mes_referencia: '2025-06-01', numero_fundos: 18 },
        { mes_referencia: '2025-07-01', numero_fundos: 25 },
        { mes_referencia: '2025-08-01', numero_fundos: 31 },
        { mes_referencia: '2025-09-01', numero_fundos: 122 },
        { mes_referencia: '2025-10-01', numero_fundos: 156 },
        { mes_referencia: '2025-11-01', numero_fundos: 168 },
        { mes_referencia: '2025-12-01', numero_fundos: 196 },
      ],
    },
    {
      title: 'PL total dos FIAGROs ao longo do ano',
      link: 'https://metabase.uqbaronline.com/question/970-evolucao-do-pl-filtered-by-data-referencia-is-before-dez-31-2025',
      description:
        'R$35,6 bilhões em dezembro de 2025. A comparação com meses anteriores do ano deve considerar as mudanças informacionais ocorridas em setembro, que ampliaram significativamente a base de dados reportada.',
      data: [
        { data_referencia: '2025-05-01', pl_total: 274308543.63 },
        { data_referencia: '2025-06-01', pl_total: 6786235520.87 },
        { data_referencia: '2025-07-01', pl_total: 7346758825.63 },
        { data_referencia: '2025-08-01', pl_total: 7981652303.32 },
        { data_referencia: '2025-09-01', pl_total: 22203246135.1 },
        { data_referencia: '2025-10-01', pl_total: 29300595039.26 },
        { data_referencia: '2025-11-01', pl_total: 43815357120.73 },
        { data_referencia: '2025-12-01', pl_total: 35603593620.72 },
      ],
    },
    {
      title: 'PL por categoria do Anexo Normativo',
      link: 'https://metabase.uqbaronline.com/question/961-pl-por-anexo-normativo-filtered-by-data-is-before-dez-31-2025',
      description:
        'R$25,6 bilhões (71,9% do PL) estão em registros sem identificação clara de anexo normativo, sujeitos apenas ao Anexo exclusivo dos FIAGROs. Dos casos identificados, o Anexo Normativo III concentra R$5,5 bilhões (15,4%) e o Anexo Normativo II, R$4,4 bilhões (12,4%).',
      data: [
        { anexo: 'Nenhum (FIAGRO)', pl_total: 25612784243.64 },
        { anexo: 'Anexo Norm. III (Imobiliário)', pl_total: 5470968687.09 },
        {
          anexo: 'Anexo Norm. II (Dir. Creditórios)',
          pl_total: 4402083431.38,
        },
        { anexo: 'Anexo Norm. I (Financeiro)', pl_total: 102781116.29 },
        { anexo: 'Anexo Norm. IV (Participações)', pl_total: 14976142.32 },
      ],
    },
    {
      title: 'PL por categoria de carteira investida',
      link: 'https://metabase.uqbaronline.com/question/963-estoque-pl-por-categoria-de-carteira-investida-filtered-by-data-is-before-dez-31-2025',
      description:
        'Direitos Creditórios e Renda Fixa formam o eixo central do mercado. Na alocação efetiva das carteiras, Renda Fixa somava R$21,0 bilhões (59,0%), Direitos Creditórios R$4,9 bilhões (13,9%), totalizando 73% do capital alocado. Imobiliário: R$3,7 bilhões (10,3%). Indeterminados: R$3,4 bilhões (9,4%).',
      data: [
        {
          categoria_carteira_investida: 'Renda Fixa',
          pl_total: 20998865073.45,
        },
        {
          categoria_carteira_investida: 'Direitos Creditórios',
          pl_total: 4944881103.1,
        },
        {
          categoria_carteira_investida: 'Imobiliário',
          pl_total: 3667394994.38,
        },
        {
          categoria_carteira_investida: 'Indeterminado',
          pl_total: 3355650682.85,
        },
        { categoria_carteira_investida: 'Cotas', pl_total: 2429618246.23 },
        {
          categoria_carteira_investida: 'Participações',
          pl_total: 178099845.08,
        },
      ],
    },
    {
      title: 'PL dos fundos com cogestão',
      link: 'https://metabase.uqbaronline.com/question/965-estoque-pl-dos-fundos-com-cogestao-grafico',
      description:
        'Três fundos com cogestão, somando R$517,0 milhões (1,5% do PL total). Fatia pequena em termos de mercado, mas relevante metodologicamente: afeta a leitura dos rankings de gestores, pois esses fundos contam para ambos os gestores.',
      data: [
        { tipo_cogestao: 'Sem cogestão', pl_total: 35087341713.22 },
        { tipo_cogestao: 'Com cogestão', pl_total: 516251907.5 },
      ],
    },
    {
      title: 'Distribuição dos FIAGROs por categoria de carteira investida',
      link: 'https://metabase.uqbaronline.com/question/967-carteira-distribuicao-dos-fiagros-por-categoria-grafico',
      description:
        '70 Renda Fixa (35,7%), 43 Indeterminados (21,9%), 38 Direitos Creditórios (19,4%), 24 Cotas, 15 Imobiliários, 6 Participações. A parcela indeterminada, com quase 22% dos fundos, ainda compromete a leitura fina do mercado.',
      data: [
        { categoria_carteira_investida: 'Renda Fixa', numero_fundos: 70 },
        { categoria_carteira_investida: 'Indeterminado', numero_fundos: 43 },
        {
          categoria_carteira_investida: 'Direitos Creditórios',
          numero_fundos: 38,
        },
        { categoria_carteira_investida: 'Cotas', numero_fundos: 24 },
        { categoria_carteira_investida: 'Imobiliário', numero_fundos: 15 },
        { categoria_carteira_investida: 'Participações', numero_fundos: 6 },
      ],
    },
    {
      title: 'Carteira vencida e a vencer — FIAGROs Direitos Creditórios',
      link: 'https://metabase.uqbaronline.com/question/969-fiagros-de-direitos-creditorios-carteira-vencida-e-a-vencer-consolidada-filtered-by-data-is-before-dez-31-2025',
      description:
        'Carteira a vencer: R$3,60 bilhões. Carteira vencida: R$769,7 milhões. O Atraso Normalizado atinge 17,6% sobre uma base de R$4,37 bilhões. Percentual alto para um recorte consolidado. A expansão do segmento de Direitos Creditórios precisa ser avaliada não só pelo volume e PL, mas pela qualidade da carteira.',
      data: [
        {
          data: '2025-05-01',
          a_vencer_total: 53140650.41,
          vencidos_total: 1691332.07,
          nivel_atraso_consolidado: 0.031,
        },
        {
          data: '2025-06-01',
          a_vencer_total: 53647482.52,
          vencidos_total: 1419456.53,
          nivel_atraso_consolidado: 0.026,
        },
        {
          data: '2025-07-01',
          a_vencer_total: 144014029.61,
          vencidos_total: 3486257.27,
          nivel_atraso_consolidado: 0.024,
        },
        {
          data: '2025-08-01',
          a_vencer_total: 378692926.51,
          vencidos_total: 24922433.33,
          nivel_atraso_consolidado: 0.062,
        },
        {
          data: '2025-09-01',
          a_vencer_total: 1633883198.33,
          vencidos_total: 351697453.77,
          nivel_atraso_consolidado: 0.18,
        },
        {
          data: '2025-10-01',
          a_vencer_total: 1583880417.69,
          vencidos_total: 474773722.95,
          nivel_atraso_consolidado: 0.23,
        },
        {
          data: '2025-11-01',
          a_vencer_total: 2391976928.09,
          vencidos_total: 704819755.04,
          nivel_atraso_consolidado: 0.23,
        },
        {
          data: '2025-12-01',
          a_vencer_total: 3600000000,
          vencidos_total: 769700000,
          nivel_atraso_consolidado: 0.176,
        },
      ],
    },
  ],
};

export const rankings = {
  intro: [
    'O maior FIAGRO é o Kinea Crédito Agro, com R$2,19 bilhões (6,2% do mercado). Os cinco maiores somam 23,4% do PL e os dez maiores, 33,4%. A concentração existe, mas não é extrema na ponta dos fundos.',
    'Entre administradores, o cenário é diferente. BTG Pactual Serviços Financeiros lidera com R$5,49 bilhões, seguido por XP Investimentos CCTVM (R$5,30 bilhões) e Intrag DTVM (R$4,61 bilhões). Os três somam 43,3% do PL; os cinco primeiros, 66,9%.',
    'Nos gestores, uma ressalva: fundos com cogestão contam para ambos os gestores, de modo que os montantes não devem ser somados. Kinea Investimentos lidera por PL (R$2,49 bilhões). Farmtech Gestão de Recursos lidera por número de fundos (22). No recorte de Direitos Creditórios e Renda Fixa, Kinea permanece à frente por PL e Eco Gestão de Ativos lidera por número de fundos (9).',
  ],
  items: [
    {
      title: 'Ranking de FIAGROs por PL',
      link: `${process.env.REACT_APP_PUBLIC_URL}/rankings/dados?market=FIAGRO&year=2025&ranking=operation&criteria=amountnetworth&timeRange=consolidated`,
      pending: false,
      description:
        'Kinea Crédito Agro: R$2,19 bilhões. Itaú Asset Rural: R$1,65 bilhão. Canaã: R$1,62 bilhão. Top 5: R$8,33 bilhões (23,4%). Top 10: 33,4%.',
      valueLabel: 'Patrimônio Líquido',
    },
    {
      title: 'Ranking de Administradores por PL',
      link: `${process.env.REACT_APP_PUBLIC_URL}/rankings/dados?market=FIAGRO&year=2025&ranking=admin&criteria=amountnetworth&timeRange=consolidated`,
      pending: false,
      description:
        'BTG Pactual Serviços Financeiros: R$5,49 bilhões. XP Investimentos CCTVM: R$5,30 bilhões. Intrag DTVM: R$4,61 bilhões. Top 3: 43,3%. Top 5: 66,9%.',
      valueLabel: 'Montante de PL',
    },
    {
      title: 'Ranking de Administradores por Número de Fundos',
      link: `${process.env.REACT_APP_PUBLIC_URL}/rankings/dados?market=FIAGRO&year=2025&ranking=admin&criteria=operations&timeRange=consolidated`,
      pending: false,
      description:
        'Oliveira Trust DTVM: 33 FIAGROs. Vórtx: 29. BTG Pactual Serviços Financeiros: 26. O ranking por quantidade difere do ranking por PL: algumas casas lideram em escala operacional, outras concentram patrimônio em fundos maiores.',
      valueLabel: 'Número de Fundos',
    },
    {
      title: 'Ranking de Gestores por PL',
      link: `${process.env.REACT_APP_PUBLIC_URL}/rankings/dados?market=FIAGRO&year=2025&ranking=manager&criteria=amountnetworth&timeRange=consolidated`,
      pending: false,
      description:
        'Kinea Investimentos: R$2,49 bilhões. Opea Gestora de Recursos: R$2,37 bilhões. XP Vista Asset Management: R$1,96 bilhão. Top 3: 19,1% do PL total, concentração inferior à observada entre administradores.',
      valueLabel: 'Montante de PL',
    },
    {
      title: 'Ranking de Gestores por Número de Fundos',
      link: `${process.env.REACT_APP_PUBLIC_URL}/rankings/dados?market=FIAGRO&year=2025&ranking=manager&criteria=operations&timeRange=consolidated`,
      pending: false,
      description:
        'Farmtech Gestão de Recursos: 22 FIAGROs. Eco Gestão de Ativos e Milênio Capital: 9 cada. A discrepância entre liderança por número e liderança por PL mostra que o mercado comporta estratégias de escala operacional sem equivalência direta em patrimônio.',
      valueLabel: 'Número de Fundos',
    },
    {
      title:
        'Ranking de Gestores de FIAGRO Dir. Creditórios e Renda Fixa por PL',
      link: `${process.env.REACT_APP_PUBLIC_URL}/rankings/dados?market=FIAGRO&year=2025&ranking=manager_pc&criteria=amountnetworth&timeRange=consolidated`,
      pending: false,
      description:
        'Kinea Investimentos: R$2,42 bilhões. Opea Gestora de Recursos: R$2,37 bilhões. XP Vista Asset Management: R$1,96 bilhão.',
      valueLabel: 'Montante de PL',
    },
    {
      title:
        'Ranking de Gestores de FIAGRO Dir. Creditórios e Renda Fixa por Número de Fundos',
      link: `${process.env.REACT_APP_PUBLIC_URL}/rankings/dados?market=FIAGRO&year=2025&ranking=manager_pc&criteria=operations&timeRange=consolidated`,
      pending: false,
      description:
        'Eco Gestão de Ativos: 9 fundos. Opea Gestora de Recursos: 8. Demais gestores com 6, 4 ou 3 fundos.',
      valueLabel: 'Número de Fundos',
    },
    {
      title: 'Ranking de Assessores Jurídicos por PL',
      link: `${process.env.REACT_APP_PUBLIC_URL}/rankings/dados?market=FIAGRO&year=2025&ranking=lawyer&criteria=amountnetworth&timeRange=consolidated`,
      pending: false,
      description:
        'VBSO aparece na liderança com R$2,01 bilhões em PL agregado dos fundos vinculados em dezembro de 2025, à frente de Pinheiro Neto (R$473,3 milhões) e Tauil e Chequer (R$452,8 milhões). O líder reúne uma massa patrimonial que o destaca de forma clara dos demais escritórios.',
      valueLabel: 'Montante de PL',
    },
    {
      title: 'Ranking de Assessores Jurídicos por Número de Fundos',
      link: `${process.env.REACT_APP_PUBLIC_URL}/rankings/dados?market=FIAGRO&year=2025&ranking=lawyer&criteria=operations&timeRange=consolidated`,
      pending: false,
      description:
        'VBSO: 12 FIAGROs vinculados. Tauil e Chequer Sociedade de Advogados e Pinheiro Neto: 4 fundos cada. O VBSO combina presença ampla no universo dos FIAGROs com liderança também em patrimônio.',
      valueLabel: 'Número de Fundos',
    },
    {
      title:
        'Ranking de Gestores de FIAGROs de Renda Fixa e Dir. Creditórios por Rentabilidade Efetiva',
      link: `${process.env.REACT_APP_PUBLIC_URL}/rankings/dados?market=FIAGRO&year=2025&ranking=manager_pc&criteria=irr&timeRange=consolidated`,
      pending: false,
      description:
        'XP Vista Asset Management lidera com 82,98%, seguida por FG/A Gestora de Recursos (46,61%) e Riza Gestora de Recursos (45,72%). O cálculo incorpora variação do preço médio de mercado das cotas entre os dois fechamentos anuais, além das distribuições de rendimentos e amortizações ao longo do período.',
      valueLabel: 'Rentabilidade Efetiva',
    },
  ],
};
